@if (!isResizing()) {
  <router-outlet></router-outlet>
}
